import React from 'react';
import { IMInputText } from '@insurancemenu/imenu-components-lib/dist/components/imForm';
import {
  IMZipCodeField,
  IMZipCountyField,
  IMZipStateField,
} from '@insurancemenu/imenu-components-lib/dist/components/imForm/capabilities/zip';
import { observer } from 'mobx-react-lite';
import { useAlliedBrokerPageStore } from 'store/pages/enrollment/broker/broker-allied/pageStore';
import { ContentSection } from 'components/common/general/ContentSection';
import { TIN_AND_GA_FORM_ID } from '../constants';
import { FormDivider, IMFormStyled } from './styles';

export const AgentDetailsForm: React.FC = observer(() => {
  const {
    agentDetailsDelegate: { form, isFormHidden },
  } = useAlliedBrokerPageStore();

  return isFormHidden ? null : (
    <ContentSection title="Review Agent Details" subtitle="Confirm the information and complete any missing fields">
      <IMFormStyled id={TIN_AND_GA_FORM_ID} formController={form}>
        <IMInputText label="First Name" name="firstName" size="m" />
        <IMInputText label="Last Name" name="lastName" size="m" />
        <IMInputText label="Email" name="email" size="full" />
        <IMInputText label="Phone" name="phone" size="m" maxLength={10} />
        <IMInputText label="NPN" name="npn" size="m" maxLength={9} />
        <FormDivider>Physical Address</FormDivider>
        <IMInputText label="City" name="city" size="m" />
        <IMInputText label="Address" name="address" size="m" />
        <IMZipCodeField size="s" />
        <IMZipStateField size="s" />
        <IMZipCountyField size="s" />
      </IMFormStyled>
    </ContentSection>
  );
});
